import { TradeOrder, updateTradeOrders } from '../reducer/strategyBuilder.reducer.ts'
import store from '../store'
import { getSecurityAsync, getSecurityKey } from './security.ts'

class PayoffManager {
    async setTrades(tradeOrders: TradeOrder[]) {
        const resolved = await Promise.all(
            tradeOrders.map(async (tradeOrder) => {
                const key = getSecurityKey(tradeOrder.security.exchange, tradeOrder.security.code)
                const security = await getSecurityAsync(key)
                return { ...tradeOrder, security: security ?? tradeOrder.security }
            })
        )
        store.dispatch(updateTradeOrders(resolved))
    }
}
export default PayoffManager
